module.exports = __webpack_public_path__ + "static/img/product-wrightin.2da1907d.png";